module.exports = __webpack_public_path__ + "img/sncf_logo.079ef235.png";